export const home = {
  // Navigation
  nav_spreadsheet: "Spreadsheet",
  nav_guides: "Guides",
  nav_categories: "Catégories",
  nav_review: "Avis",
  nav_shipping: "Livraison",
  nav_safety: "Sécurité",
  nav_blog: "Blog",
  nav_home: "Accueil",
  nav_shopping_guide: "Guide d'achat",
  nav_about: "À propos",
  nav_contact: "Contact",
  
  // Language selector
  lang_english: "English",
  lang_french: "Français",
  lang_german: "Deutsch",
  lang_danish: "Dansk",
  
  // Hero
  hero_eyebrow: "LE HUB DE RESSOURCES ALLCHINABUY SPREADSHEET",
  hero_h1: "AllChinaBuy Spreadsheet — Trouvez des produits, vendeurs et ressources d'achat plus rapidement",
  hero_subheadline: "Découvrez des spreadsheets AllChinaBuy utiles, des ressources de vendeurs de confiance, des guides de produits, des informations QC, des conseils de livraison et des guides d'achat — tous organisés dans un hub simple.",
  hero_cta_primary: "Explorer AllChinaBuy Spreadsheet",
  hero_cta_secondary: "Parcourir les ressources populaires",
  hero_trust: "Ressource indépendante • Mise à jour régulièrement • Conçu pour une découverte plus facile",
  
  // Search Module
  search_title: "Trouvez la ressource AllChinaBuy Spreadsheet dont vous avez besoin",
  search_placeholder: "Rechercher produits, vendeurs, livraison, QC, entrepôt...",
  search_button: "Rechercher",
  search_popular: "Recherches populaires",
  search_popular_items: "Vêtements • Chaussures • Mode • QC • Livraison • Vendeurs",
  
  // Spreadsheet Hub Section
  hub_h2: "AllChinaBuy Spreadsheet : Votre point de départ",
  hub_copy: "Vous cherchez des produits, des vendeurs ou des informations d'achat utiles ? Commencez avec le hub AllChinaBuy Spreadsheet et explorez des ressources organisées par catégorie, type de produit et intention de recherche.",
  hub_cta: "Explorer le hub Spreadsheet →",
  
  // Popular Categories
  categories_h2: "Catégories populaires AllChinaBuy Spreadsheet",
  categories_clothing: "Vêtements",
  categories_clothing_desc: "Parcourez le dernier spreadsheet AllChinaBuy vêtements avec des vendeurs de confiance, des articles de qualité et des guides de tailles pour le streetwear et les vêtements décontractés.",
  categories_shoes: "Chaussures",
  categories_shoes_desc: "Explorez le spreadsheet AllChinaBuy chaussures avec des sneakers, bottes, sandales et plus de vendeurs vérifiés avec des informations QC détaillées.",
  categories_fashion: "Mode",
  categories_fashion_desc: "Découvrez les articles de mode tendance dans le spreadsheet AllChinaBuy — collections sélectionnées, choix saisonniers et guides de style.",
  categories_electronics: "Électronique",
  categories_electronics_desc: "Trouvez des produits électroniques et gadgets dans le spreadsheet AllChinaBuy, incluant accessoires, wearables tech et appareils quotidiens.",
  categories_accessories: "Accessoires",
  categories_accessories_desc: "Achetez ceintures, sacs, bijoux, montres et plus via le spreadsheet AllChinaBuy accessoires avec des évaluations de vendeurs détaillées.",
  categories_sellers: "Vendeurs de confiance",
  categories_sellers_desc: "Accédez au spreadsheet AllChinaBuy vendeurs de confiance avec des avis vérifiés, des évaluations et des spécialités produits pour acheter en toute confiance.",
  
  // Latest Resources
  resources_h2: "Dernières ressources AllChinaBuy",
  resources_read: "Lire le guide →",
  pillar_h2: "Guides essentiels AllChinaBuy",
  pillar_subtitle: "Des articles détaillés couvrant chaque étape du parcours d'achat AllChinaBuy",
  
  // Buying Guides
  guides_h2: "Guides d'achat AllChinaBuy",
  guides_qc: "Guide QC",
  guides_qc_desc: "Apprenez à demander, lire et évaluer les photos QC avant d'expédier vos commandes AllChinaBuy.",
  guides_shipping: "Guide de livraison",
  guides_shipping_desc: "Comparez les méthodes de livraison, comprenez les coûts, les délais et choisissez la meilleure option pour votre pays.",
  guides_warehouse: "Guide d'entrepôt",
  guides_warehouse_desc: "Comprenez comment fonctionne le processus d'entrepôt AllChinaBuy — stockage, inspection, emballage et expédition.",
  guides_seller: "Guide des vendeurs",
  guides_seller_desc: "Conseils pour trouver des vendeurs fiables, lire les avis et éviter les erreurs courantes lors des achats.",
  guides_safety: "Guide de sécurité",
  guides_safety_desc: "Protégez-vous avec les meilleures pratiques pour la sécurité du compte, la sécurité des paiements et la vigilance contre les arnaques.",
  
  // Review Section
  review_h2: "Avis AllChinaBuy",
  review_copy: "Vous cherchez un aperçu impartial ? Explorez notre avis AllChinaBuy couvrant les fonctionnalités clés, le workflow d'achat, les informations d'entrepôt, les considérations de livraison, les conseils de sécurité et les points importants à connaître avant d'utiliser la plateforme.",
  review_cta: "Lire l'avis AllChinaBuy →",
  
  // Safety Section
  safety_h2: "Achetez plus intelligemment : Guide de sécurité AllChinaBuy",
  safety_copy: "Avant d'acheter, comprenez la vérification des vendeurs, les photos QC, la sécurité des paiements, les liens suspects, la protection du compte et les risques d'achat courants.",
  safety_cta: "Lire le guide de sécurité →",
  
  // Final CTA
  final_cta_h2: "Prêt à explorer les ressources AllChinaBuy ?",
  final_cta_copy: "Commencez avec AllChinaBuy Spreadsheet et découvrez des ressources produit, vendeur, livraison et achat organisées pour une recherche plus rapide.",
  final_cta_primary: "Explorer AllChinaBuy Spreadsheet",
  final_cta_secondary: "Visiter notre site principal",
  
  // Category Dropdown
  dropdown_title: "Catégories de shopping",
  dropdown_all: "Toutes les catégories",
  
  // Main CTAs
  btn_main_site: "AllChinaBuy Spreadsheet",
  btn_buy_now: "Acheter maintenant",
  
  // Footer
  footer_spreadsheet: "Spreadsheet",
  footer_guides: "Guides",
  footer_reviews: "Avis",
  footer_shipping: "Livraison",
  footer_safety: "Sécurité",
  footer_resources: "Ressources",
  footer_about: "À propos",
  footer_contact: "Contact",
  footer_privacy: "Politique de confidentialité",
  footer_terms: "Conditions",
  footer_disclaimer: "Avertissement",
  footer_disclaimer_text: "AllChinaBuy Spread est une ressource d'information indépendante et n'est pas affiliée ni exploitée par AllChinaBuy, sauf mention explicite.",
  footer_copyright: "© 2026 AllChinaBuy Spreadsheet. Tous droits réservés.",
  
  // Meta
  meta_title: "AllChinaBuy Spreadsheet 2026 : Guide complet et meilleures ressources",
  meta_description: "Découvrez AllChinaBuy Spreadsheet — votre hub de ressources indépendant pour produits, vendeurs, guides QC, conseils de livraison et ressources d'achat. Mis à jour régulièrement.",
  
  // Category names (for dropdown)
  cat_shoes: "Chaussures",
  cat_hoodies: "Sweats/Pulls",
  cat_tshirts: "T-Shirts",
  cat_jackets: "Vestes",
  cat_pants: "Pantalons/Shorts",
  cat_headwear: "Coiffures",
  cat_sets: "Ensembles",
  cat_underwear: "Sous-vêtements",
  cat_jersey: "Maillots",
  cat_accessories: "Accessoires",
  cat_bags: "Sacs",
  cat_belts: "Ceintures",
  cat_perfumes: "Parfums",
  cat_other: "Autres",
};